import { render, staticRenderFns } from "./careinstitution.vue?vue&type=template&id=28202458&scoped=true&"
import script from "./careinstitution.vue?vue&type=script&lang=js&"
export * from "./careinstitution.vue?vue&type=script&lang=js&"
import style0 from "./careinstitution.vue?vue&type=style&index=0&id=28202458&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28202458",
  null
  
)

export default component.exports